if (!customElements.get('iwt-reserve-button')) {
  customElements.define(
    'iwt-reserve-button',
    class IwtReserveButton extends HTMLElement {
      connectedCallback() {
        this.onActivate = this.onActivate.bind(this);
        this.addEventListener('click', this.onActivate);
        this.addEventListener('keydown', this.onKeyDown);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onActivate);
        this.removeEventListener('keydown', this.onKeyDown);
      }

      onKeyDown(event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        this.onActivate(event);
      }

      onActivate(event) {
        event.preventDefault();
        if (this.classList.contains('is-loading') || this.getAttribute('aria-disabled') === 'true') return;

        const variantId = Number(this.dataset.variantId);
        const checkoutUrl = this.dataset.checkoutUrl || `${window.routes?.root_url || '/'}checkout`;
        if (!variantId || !window.routes?.cart_add_url) return;

        this.setAttribute('aria-disabled', 'true');
        this.classList.add('is-loading');

        const config =
          typeof fetchConfig === 'function'
            ? fetchConfig('javascript')
            : {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', Accept: 'application/javascript' },
              };
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        config.body = JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
        });

        fetch(window.routes.cart_add_url, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              this.classList.remove('is-loading');
              this.removeAttribute('aria-disabled');
              return;
            }

            window.location.assign(checkoutUrl);
          })
          .catch(() => {
            this.classList.remove('is-loading');
            this.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
